export default __webpack_public_path__ + "static/media/technician_tab.55f03860.svg";